import { render, staticRenderFns } from "./PurchaseReturnTemplate.vue?vue&type=template&id=f166c3fc&scoped=true&"
import script from "./PurchaseReturnTemplate.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReturnTemplate.vue?vue&type=style&index=0&id=f166c3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f166c3fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
